import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import StorefrontAPI from 'utilities/storefrontApi';
import { SHELL, MAX, CARD, SUB_INPUT, BUTTON, brandPath } from './styles';
import useBrand from './useBrand';
import StorefrontNav from './StorefrontNav';
import { ShellMessage, Field } from './shellHelpers';

/** Customer-facing "get in touch" form. Posts to the brand's contact inbox. */
export default function StorefrontContact() {
  const { brand, error } = useBrand();
  const [form, setForm] = useState({ name: '', email: '', subject: '', body: '' });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState('');
  const accent = brand?.brand_color || '#422AFB';

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!brand?._id) return;
    setErr(''); setBusy(true);
    try {
      await StorefrontAPI.submitContact(brand._id, form);
      setDone(true);
      setForm({ name: '', email: '', subject: '', body: '' });
    } catch (e2) {
      setErr(e2?.message || 'Could not send your message');
    } finally {
      setBusy(false);
    }
  };

  if (error) return <ShellMessage>{error}</ShellMessage>;
  if (!brand) return <ShellMessage>Loading…</ShellMessage>;

  return (
    <div style={SHELL}>
      <StorefrontNav brand={brand} />
      <div style={MAX}>
        <h1 style={{ fontSize: 28, margin: '8px 0 18px' }}>Get in touch</h1>
        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 2fr) minmax(0, 1fr)', gap: 24 }}>
          <form onSubmit={submit} style={CARD}>
            {done ? (
              <div>
                <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 6 }}>Message sent ✓</div>
                <div style={{ color: '#475569', fontSize: 13, marginBottom: 12 }}>
                  Thanks — we’ll get back to you at the email you provided.
                </div>
                <button type='button' onClick={() => setDone(false)} style={{ ...BUTTON(accent, true) }}>
                  Send another
                </button>
              </div>
            ) : (
              <>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                  <Field label='Your name'>
                    <input style={SUB_INPUT} value={form.name} onChange={set('name')} required />
                  </Field>
                  <Field label='Your email'>
                    <input style={SUB_INPUT} type='email' value={form.email} onChange={set('email')} required />
                  </Field>
                </div>
                <Field label='Subject'>
                  <input style={SUB_INPUT} value={form.subject} onChange={set('subject')} placeholder='Optional' />
                </Field>
                <Field label='Message'>
                  <textarea
                    style={{ ...SUB_INPUT, minHeight: 120, resize: 'vertical' }}
                    value={form.body}
                    onChange={set('body')}
                    required
                  />
                </Field>
                {err && <div style={{ color: '#dc2626', fontSize: 13, marginTop: 6 }}>{err}</div>}
                <button type='submit' disabled={busy} style={{ ...BUTTON(accent), width: '100%', marginTop: 8 }}>
                  {busy ? 'Sending…' : 'Send message'}
                </button>
              </>
            )}
          </form>
          <div style={CARD}>
            <div style={{ fontWeight: 700, fontSize: 14, color: '#475569', marginBottom: 8 }}>
              Quick links
            </div>
            <Link to={brandPath(brand, '/track')} style={{ color: accent, fontWeight: 600, fontSize: 13, display: 'block', marginBottom: 6 }}>
              Track an existing order
            </Link>
            <Link to={brandPath(brand, '/shop')} style={{ color: accent, fontWeight: 600, fontSize: 13 }}>
              Browse the shop
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
